
































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
// import {
//     TweenMax,
//     TimelineLite,
//     Power3,
//     Power4,
//     Power1,
//     Power2,
//     TimelineMax,
// } from 'gsap';
// import ScrollMagic from "scrollmagic";
// import gsap from 'scrollmagic';
@Component({
    name: "HomeTextblock",
})
export default class HomeTextblock extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    @Prop() public compData!: string | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    // @Prop() public controller!: any | null;
    // @Prop() public controller1!: any | null;
    // public hmtxtanim() {

    //     const tl1 = new TimelineMax()
    //         .from('.main-title .sub-title', 1, {
    //             yPercent: 20,
    //             autoAlpha: 0,
    //             ease: Power2.easeOut,
    //             clearProps: 'all'
    //         })
    //         .from('.main-title .m-title', 1, {
    //             yPercent: 20,
    //             autoAlpha: 0,
    //             scale: 1.09,
    //             ease: Power2.easeOut,
    //             clearProps: 'all'
    //         })

    //     const controller = new ScrollMagic.Controller();

    //     const scene = new ScrollMagic.Scene({
    //             triggerElement: ".home-texanim",
    //             reverse: false,
    //             // duration: 1000,
    //             //triggerHook: "onEnter"
    //         })
    //         .setTween(tl1)
    //         .addTo(controller);

    //     const tl2 = new TimelineMax()
    //         .from('.design-anim', .8, {
    //             yPercent: 80,
    //             // height: 0,
    //             autoAlpha: 0,
    //             ease: Power2.easeOut,
    //             clearProps: 'all'
    //         })
    //     const controller1 = new ScrollMagic.Controller();

    //     const scene1 = new ScrollMagic.Scene({
    //             triggerElement: ".design-anim",
    //             reverse: false,
    //             //triggerHook: "onEnter"
    //         })
    //         .setTween(tl2)
    //         .addTo(controller1);

    // }
    // public mounted() {
    //     this.hmtxtanim();
    // }
}
